import { useState } from "react";
import {
  Typography,
  Select,
  MenuItem,
  Button,
  Box,
  IconButton,
  InputAdornment,
  FormControl,
  TextField,
} from "@mui/material";
import { useFormik } from "formik";
import { loginschema } from "../schema/schema";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { login } from "../../services/services";
import { setCurrentAccessToken } from "../../services/axiosClient";
import { roles } from "../utils/Data";
import { useSnackbar } from "../utils/SnackBar";

const Login = () => {
  const navigate = useNavigate();
  const showSnackbar = useSnackbar();
  const hendelonClick = () => {
    navigate("/forgot-password");
  };

  const [showPassword, setShowPassword] = useState(false);
  const [openProfile, setOpenProfile] = useState(false);

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
      role: "",
    },
    validationSchema: loginschema,
    onSubmit: (values) => {
      let payload: any = { ...values };
      delete payload.role;
      payload.status = "CREATED";
      console.log(payload);
      login(payload)
        .then((result: any) => {
          const accessToken = result?.data?.data?.accessToken;
          const refreshToken = result?.data?.data?.refreshToken;

          if (accessToken) {
            localStorage.setItem("accessToken", accessToken);
          }

          if (refreshToken) {
            localStorage.setItem("refreshToken", refreshToken);
          }

          showSnackbar(result?.data?.message || "Login successful");
          window.location.href = "/";
        })
        .catch((error) => {
          showSnackbar(
            error?.response?.data?.message || error?.response?.data?.msg,
          );
        });
    },
  });

  return (
    <>
      <Typography
        variant="h4"
        align="center"
        gutterBottom
        sx={{ color: "#321548", fontWeight: "700", mb: 3 }}
      >
        Welcome Back
      </Typography>
      <Box component="form" onSubmit={formik.handleSubmit}>
        <TextField
          className="input-root2"
          placeholder="Email"
          variant="outlined"
          fullWidth
          sx={{
            mb: 2,
            background: "white",
            borderRadius: 3,
          }}
          name="email"
          value={formik.values.email}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.email && Boolean(formik.errors.email)}
          helperText={formik.touched.email && formik.errors.email}
        />
        <TextField
          className="input-root2"
          placeholder="Password"
          type={showPassword ? "text" : "password"}
          variant="outlined"
          fullWidth
          sx={{
            mb: 2,
            background: "white",
            borderRadius: 3,
          }}
          name="password"
          value={formik.values.password}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.password && Boolean(formik.errors.password)}
          helperText={formik.touched.password && formik.errors.password}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={handleClickShowPassword} edge="end">
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />

        <Typography
          sx={{
            textAlign: "right",
            color: "#360076",
            cursor: "pointer",
            mb: 4,
          }}
          onClick={hendelonClick}
        >
          Forgot password?
        </Typography>

        <FormControl
          className="input-root2"
          variant="outlined"
          fullWidth
          sx={{ mb: 2, background: "white", borderRadius: 3 }}
        >
          {/* <InputLabel>Select Profile</InputLabel> */}
          <Select
            placeholder="Select Profile"
            name="role"
            value={formik.values.role}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.role && Boolean(formik.errors.role)}
            // endAdornment={(
            //     <InputAdornment position="end">
            //         <IconButton edge="end" onClick={handleClickProfile}>
            //             {openProfile ? <KeyboardArrowUpIcon /> : <KeyboardArrowDown />}
            //         </IconButton>
            //     </InputAdornment>
            // )}
            open={openProfile}
            onClose={() => setOpenProfile(false)}
            onOpen={() => setOpenProfile(true)}
            displayEmpty
            renderValue={(selected: any) => {
              if (!selected) {
                return "Select Profile";
              }
              return selected;
            }}
          >
            {/* <MenuItem value="" disabled>
              Select Profile
            </MenuItem> */}
            {roles.map((role: any, index: number) => (
              <MenuItem key={index} value={role}>
                {role}
              </MenuItem>
            ))}
          </Select>
          {formik.touched.role && formik.errors.role && (
            <Typography color="error" variant="caption">
              {formik.errors.role}
            </Typography>
          )}
        </FormControl>

        <Button
          variant="contained"
          fullWidth
          sx={{
            mt: 2,
            backgroundColor: "#35185A",
            borderRadius: 3,
            textTransform: "none",
            color: "white",
            height: "50px",
          }}
          type="submit"
          disabled={!(formik.isValid && formik.dirty)}
        >
          Login
        </Button>
      </Box>
    </>
  );
};

export default Login;
